import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getCheckinsIcon,
  getWithTrainerIcon,
  getTrialsIcon,
  getBCAPendingIcon,
  getUnassignedIcon,
  // getHourlyIcon,
  getChevronIcon,
  getUtilizationType,
} from "../MemberReportMocks.js";
import CalendarLoader from "../../../common-components/CalendarLoader.jsx";
import MemberPopover from "../member-popover/MemberPopover.jsx";

const GymMemberReport = ({ setModValues, userInfoData, filters }) => {
  const {
    gymwiseCheckinMetrics,
    gymwiseCheckinMetricsLoading,
    gymwiseCheckinMetricsError,
  } = useSelector((state) => state.prospects);

  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  const [popoverState, setPopoverState] = useState({
    isOpen: false,
    type: null,
    gymId: null,
    memberCount: 0,
    position: { top: 0, left: 0 },
  });

  const handlePopoverOpen = (event, type, gymId, memberCount) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setPopoverState({
      isOpen: true,
      type: type,
      gymId: gymId,
      memberCount: memberCount,
      position: {
        top: rect.top + window.scrollY,
        left: rect.left + rect.width / 2,
      },
    });
  };

  const handlePopoverClose = () => {
    setPopoverState({
      isOpen: false,
      type: null,
      gymId: null,
      memberCount: 0,
      position: { top: 0, left: 0 },
    });
  };

  useEffect(() => {
    if (
      !gymwiseCheckinMetricsLoading &&
      !gymwiseCheckinMetricsError &&
      gymwiseCheckinMetrics?.status &&
      gymwiseCheckinMetrics?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: gymwiseCheckinMetrics.data,
        pagination:
          gymwiseCheckinMetrics?.pagination?.length > 0
            ? gymwiseCheckinMetrics.pagination
            : [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [
    gymwiseCheckinMetricsLoading,
    gymwiseCheckinMetricsError,
    gymwiseCheckinMetrics,
  ]);

  return (
    <section className="mr-gc-grid mt30 mb30" aria-label="Gym locations">
      {gymwiseCheckinMetricsLoading ? (
        <CalendarLoader
          daysCount={allDatas.allData.length || 4}
          shiftsPerDay={4}
        />
      ) : (
        allDatas.allData.map((gym) => (
          <article
            key={gym?.gym_id || ""}
            className="mr-gc-card"
            role="button"
            tabIndex={0}
            aria-label={`Open ${gym?.gym_name || ""} details`}
          >
            <header className="mr-gc-head">
              <div className="mr-gc-head-left">
                <h3 className="mr-gc-title">{gym?.gym_name || "NA"}</h3>
                <div className="mr-gc-subrow">
                  <span className="mr-badge mr-badge--secondary">
                    {gym?.category_name || ""}
                  </span>
                  {/* <span
                  className={`mr-badge mr-badge--${
                    gym.status === "active" ? "success" : "danger"
                  }`}
                >
                  {gym.status}
                </span> */}
                  {/* <span className="mr-badge mr-badge--secondary">{gym.code}</span>
                <span className={`mr-badge mr-badge--${gym.statusType}`}>
                  {gym.status}
                </span> */}
                </div>
              </div>

              <div
                className="mr-gc-chevron"
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "gym-report",
                    rowData: gym,
                  }))
                }
              >
                {getChevronIcon()}
              </div>
            </header>

            <div className="mr-gc-two-up">
              <div className="mr-gc-stat">
                <div className="mr-gc-stat-label">
                  <div className="mr-gc-qicon mr-gc-qicon--info">
                    {getCheckinsIcon()}
                  </div>
                  <span>Check-ins</span>
                </div>
                <div className="mr-gc-stat-value">
                  {gym.metrics?.total_checkins?.value || 0}
                </div>
              </div>
              <div className="mr-gc-stat">
                <div className="mr-gc-stat-label">
                  <div className="mr-gc-qicon mr-gc-qicon--success">
                    {getWithTrainerIcon()}
                  </div>
                  <span>With Trainer</span>
                </div>
                <div className="mr-gc-stat-value">
                  {gym.metrics?.with_trainer?.value || 0}
                </div>
              </div>
            </div>

            <div className="mr-gc-util" aria-label="Trainer utilization">
              <div className="mr-gc-util-row">
                <span className="mr-gc-util-label">Trainer Utilization</span>
                <span
                  className={`mr-gc-util-rate is-${getUtilizationType(
                    parseInt(
                      gym.metrics?.trainer_avg_utilization?.value?.replace(
                        "%",
                        ""
                      ) || "0"
                    )
                  )}`}
                >
                  {gym.metrics?.trainer_avg_utilization?.value || "0%"}
                </span>
              </div>
              <div className="mr-gc-util-track" aria-hidden="true">
                <div
                  className={`mr-gc-util-fill is-${getUtilizationType(
                    parseInt(
                      gym.metrics?.trainer_avg_utilization?.value?.replace(
                        "%",
                        ""
                      ) || "0"
                    )
                  )}`}
                  style={{
                    width: `${
                      gym.metrics?.trainer_avg_utilization?.value || "0%"
                    }`,
                  }}
                />
              </div>
              <span className="mr-gc-visually-hidden">
                Current utilization is{" "}
                {gym.metrics?.trainer_avg_utilization?.value || "0%"}
              </span>
            </div>

            <div className="mr-gc-quick" aria-label="Key metrics">
              <div
                className={`mr-gc-qitem ${
                  (gym.metrics?.active_trials?.value || 0) > 0
                    ? "mr-gc-qitem--clickable"
                    : "mr-gc-qitem--disabled"
                }`}
                onClick={
                  (gym.metrics?.active_trials?.value || 0) > 0
                    ? (e) =>
                        handlePopoverOpen(
                          e,
                          "trial",
                          gym.gym_id,
                          gym.metrics?.active_trials?.value || 0
                        )
                    : undefined
                }
                style={{
                  cursor:
                    (gym.metrics?.active_trials?.value || 0) > 0
                      ? "pointer"
                      : "default",
                }}
                title={
                  (gym.metrics?.active_trials?.value || 0) > 0
                    ? "Click to view trial members"
                    : "No trial members available"
                }
              >
                <div className="mr-gc-qicon mr-gc-qicon--info">
                  {getTrialsIcon()}
                </div>
                <div className="mr-gc-qname">Trials</div>
                <div className="mr-gc-qval">
                  {gym.metrics?.active_trials?.value || 0}
                </div>
              </div>
              <div
                className={`mr-gc-qitem ${
                  (gym.metrics?.bca_pending?.value || 0) > 0
                    ? "mr-gc-qitem--clickable"
                    : "mr-gc-qitem--disabled"
                }`}
                onClick={
                  (gym.metrics?.bca_pending?.value || 0) > 0
                    ? (e) =>
                        handlePopoverOpen(
                          e,
                          "bca_pending",
                          gym.gym_id,
                          gym.metrics?.bca_pending?.value || 0
                        )
                    : undefined
                }
                style={{
                  cursor:
                    (gym.metrics?.bca_pending?.value || 0) > 0
                      ? "pointer"
                      : "default",
                }}
                title={
                  (gym.metrics?.bca_pending?.value || 0) > 0
                    ? "Click to view BCA pending members"
                    : "No BCA pending members available"
                }
              >
                <div className="mr-gc-qicon mr-gc-qicon--warning">
                  {getBCAPendingIcon()}
                </div>
                <div className="mr-gc-qname">BCA Pending</div>
                <div className="mr-gc-qval">
                  {gym.metrics?.bca_pending?.value || 0}
                </div>
              </div>
              <div
                className={`mr-gc-qitem ${
                  (gym.metrics?.unassigned?.value || 0) > 0
                    ? "mr-gc-qitem--clickable"
                    : "mr-gc-qitem--disabled"
                }`}
                onClick={
                  (gym.metrics?.unassigned?.value || 0) > 0
                    ? (e) =>
                        handlePopoverOpen(
                          e,
                          "unassigned",
                          gym.gym_id,
                          gym.metrics?.unassigned?.value || 0
                        )
                    : undefined
                }
                style={{
                  cursor:
                    (gym.metrics?.unassigned?.value || 0) > 0
                      ? "pointer"
                      : "default",
                }}
                title={
                  (gym.metrics?.unassigned?.value || 0) > 0
                    ? "Click to view unassigned members"
                    : "No unassigned members available"
                }
              >
                <div className="mr-gc-qicon mr-gc-qicon--danger">
                  {getUnassignedIcon()}
                </div>
                <div className="mr-gc-qname">Unassigned</div>
                <div className="mr-gc-qval">
                  {gym.metrics?.unassigned?.value || 0}
                </div>
              </div>
            </div>

            {/* Hourly (optional) */}
            {/* <div className="mr-gc-hourly" aria-label="Hourly metrics">
            <div className="mr-gc-hourly-head">
              <div className="mr-gc-qicon">{getHourlyIcon()}</div>
              <strong style={{ fontSize: "0.78rem" }}>Hourly Metrics</strong>
              <span className="mr-gc-hourly-dot" aria-hidden="true" />
            </div>
            <div className="mr-gc-hourly-grid">
              <div className="mr-gc-hourly-cell">
                <div className="mr-gc-hourly-name">Rate/hr</div>
                <div className="mr-gc-hourly-val">
                  {gym.hourlyMetrics.ratePerHour}
                </div>
              </div>
              <div className="mr-gc-hourly-cell">
                <div className="mr-gc-hourly-name">Conv%</div>
                <div className="mr-gc-hourly-val">
                  {gym.hourlyMetrics.conversion}%
                </div>
              </div>
              <div className="mr-gc-hourly-cell">
                <div className="mr-gc-hourly-name">Wait</div>
                <div className="mr-gc-hourly-val">
                  {gym.hourlyMetrics.waitTime}
                </div>
              </div>
            </div>
          </div> */}
          </article>
        ))
      )}

      <MemberPopover
        isOpen={popoverState.isOpen}
        onClose={handlePopoverClose}
        popoverType={popoverState.type}
        gymId={popoverState.gymId}
        memberCount={popoverState.memberCount}
        filters={filters}
        userInfoData={userInfoData}
        position={popoverState.position}
        setModValues={setModValues}
      />
    </section>
  );
};

export default GymMemberReport;
